<template>
  <div class="pipeline-visual" aria-hidden="true">
    <div class="pipeline-visual__screen">
      <div
        v-for="column in columns"
        :key="column.phase"
        class="pipeline-visual__column"
        :class="`pipeline-visual__column--${column.tone}`"
      >
        <span class="pipeline-visual__phase">{{ column.phase }}</span>
        <div
          v-for="deal in column.deals"
          :key="deal.name"
          class="pipeline-visual__deal"
          :class="{ 'pipeline-visual__deal--selected': deal.selected }"
        >
          <div class="pipeline-visual__deal-top">
            <span>{{ deal.name }}</span>
            <span>{{ deal.value }}</span>
          </div>
          <div class="pipeline-visual__deal-meta">
            <ShowcaseAvatar :person="deal.owner" />
            <span :class="`pipeline-visual__activity--${deal.activityTone}`">
              {{ deal.activity }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="pipeline-visual__dropdown">
      <div
        v-for="owner in owners"
        :key="owner.name"
        class="pipeline-visual__option"
        :class="{ 'pipeline-visual__option--selected': owner.selected }"
      >
        <ShowcaseAvatar :person="owner.person" />
        <span>{{ owner.name }}</span>
        <span v-if="owner.selected" class="pipeline-visual__check">✓</span>
      </div>
    </div>
  </div>
</template>

<script>
  import ShowcaseAvatar from './ShowcaseAvatar.vue';

  export default {
    name: 'PipelineVisual',
    components: { ShowcaseAvatar },
    setup() {
      const columns = [
        {
          phase: 'CONTACT OPGENOMEN',
          tone: 'blue',
          deals: [
            {
              name: 'J. Bakker',
              value: '€7.925',
              owner: 'bart',
              activity: 'Nieuwe notitie · 1u',
              activityTone: 'primary',
            },
            {
              name: 'L. Mulder',
              value: '€24.900',
              owner: 'bart',
              activity: 'Offerte bekeken · 3d',
              activityTone: 'text',
            },
            {
              name: 'A. Meijer',
              value: '€960',
              owner: 'sander',
              activity: 'Taak verlopen · 2d',
              activityTone: 'red',
            },
          ],
        },
        {
          phase: 'PRO FORMA VERZONDEN',
          tone: 'purple',
          deals: [
            {
              name: 'T. Bos',
              value: '€1.875',
              owner: 'cas',
              activity: 'Nieuwe notitie · 4u',
              activityTone: 'primary',
            },
            {
              name: 'N. Hendriks',
              value: '€14.720',
              owner: 'sander',
              activity: 'Taak verlopen · 1d',
              activityTone: 'red',
              selected: true,
            },
            {
              name: 'S. Visser',
              value: '€18.640',
              owner: 'cas',
              activity: 'Inactief · 7d',
              activityTone: 'orange',
            },
          ],
        },
      ];

      const owners = [
        { name: 'Bart Oosterveer', person: 'bart' },
        { name: 'Cas van Grunsven', person: 'cas' },
        { name: 'Sander Brands', person: 'sander', selected: true },
      ];

      return { columns, owners };
    },
  };
</script>

<style scoped lang="scss">
  .pipeline-visual {
    position: relative;
    width: 540px;
    max-width: 100%;
    color: var(--showcase-ink);

    &__screen {
      display: flex;
      gap: 8px;
      padding: 14px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 10px;
      background-color: #ececec;
      box-shadow:
        0 1px 2px rgba(0, 9, 33, 0.06),
        0 8px 24px rgba(0, 9, 33, 0.07);
    }

    &__column {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      min-width: 0;
      padding: 8px;
      border-radius: 8px;
      &--blue {
        background-color: var(--showcase-blue-bg);
        --phase-color: var(--showcase-primary);
      }
      &--purple {
        background-color: var(--showcase-purple-bg);
        --phase-color: #7c4ddb;
      }
    }

    &__phase {
      margin: 0 2px 2px;
      padding: 0 6px;
      border-radius: 4px;
      background-color: var(--phase-color);
      color: var(--white);
      font-size: 10px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0.3px;
      white-space: nowrap;
    }

    &__deal {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      padding: 9px 11px;
      border: 1.5px solid transparent;
      border-radius: 6px;
      background-color: var(--white);
      box-shadow: 0 1px 2px rgba(0, 9, 33, 0.06);
      &--selected {
        border-color: var(--showcase-primary);
        background-color: var(--showcase-primary-tint);
      }
    }

    &__deal-top {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      white-space: nowrap;
    }

    &__deal-meta {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      line-height: 18px;
      white-space: nowrap;
    }

    &__activity {
      &--primary {
        color: var(--showcase-primary);
      }
      &--text {
        color: var(--showcase-text);
      }
      &--red {
        color: #d93636;
      }
      &--orange {
        color: #e08a00;
      }
    }

    &__dropdown {
      position: absolute;
      right: -35px;
      bottom: -53px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 190px;
      padding: 6px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 8px;
      background-color: var(--white);
      box-shadow:
        0 1px 2px rgba(0, 9, 33, 0.06),
        0 8px 24px rgba(0, 9, 33, 0.07);
    }

    &__option {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 12.5px;
      line-height: 18px;
      white-space: nowrap;
      &--selected {
        background-color: #f3f3f3;
      }
    }

    &__check {
      margin-left: auto;
      color: var(--showcase-primary);
    }
  }
</style>
